import Applicants from './Applicants'

export default Applicants
